// Utilitários de concordância de gênero e nome, usados para eliminar
// sufixos "(a)" na interface (regra do projeto: PT-BR sempre concordado,
// nunca "Bem-vindo(a)"). Usa o campo `gender` do perfil ("M" | "F" | "NB" | "NI").

export type Gender = 'M' | 'F' | 'NB' | 'NI' | null | undefined;

/** Primeiro nome — nunca use o nome completo de cadastro para se dirigir ao usuário. */
export const firstName = (fullName?: string | null): string => {
  if (!fullName) return '';
  return fullName.trim().split(/\s+/)[0];
};

interface AgreeOptions {
  /** Forma masculina (gender === 'M') */
  m: string;
  /** Forma feminina (gender === 'F') */
  f: string;
  /** Forma neutra — usada para NB, NI ou gênero ainda não informado. Nunca "(a)". */
  neutral: string;
}

/** Concorda um texto (adjetivo/particípio) com o gênero do perfil, sem sufixos "(a)". */
export const agree = (gender: Gender, { m, f, neutral }: AgreeOptions): string => {
  if (gender === 'M') return m;
  if (gender === 'F') return f;
  return neutral;
};

/**
 * Remove sufixos "(a)" de textos livres (ex.: pools de afirmações/reflexões),
 * concordando para o feminino quando o gênero é F. Cobre o padrão comum
 * "<palavra>o(a)" (ex.: "pioneiro(a)" → "pioneira"/"pioneiro").
 * Para M, NB, NI ou gênero não informado, mantém a forma masculina sem o
 * sufixo — é uma simplificação (português não tem uma 3ª forma padronizada
 * para textos curtos como esses), documentada aqui para não repetir a
 * decisão em cada lugar que usa a função.
 */
export const degender = (text: string, gender: Gender): string => {
  if (gender === 'F') return text.replace(/(\w)o\(a\)/gi, '$1a');
  return text.replace(/\(a\)/g, '');
};
